import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-10 h-10" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.imageUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "inline object-cover rounded-full",
          src: _ctx.imageUrl,
          alt: "avatar"
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["w-10 h-10 flex justify-center items-center rounded-full text-white font-medium uppercase", _ctx.bgColor])
        }, _toDisplayString(_ctx.userName), 3))
  ]))
}